import { ArSdk, isWebGLSupported } from 'tencentcloud-webar';
import NOTICE from '../notice';

const SDK_STATE = {
  UNINITIALIZED: 0,
  CREATED: 1,
  CAMERA_READY: 2,
  RESOURCE_READY: 2,
  READY: 3,
};

const config = {
  module: {
    beautify: true,
    segmentation: true,
  },
};
/**
 * @type {TalBeauty | null}
 */
let sdk = null;
let isUsing = false;
export class TalBeauty extends ArSdk {
  static get sdk() {
    return sdk;
  }
  static get isUsing() {
    return isUsing;
  }
  static get SDK_STATE() {
    return SDK_STATE;
  }

  /**
   * @param {Object} params
   * @param {string} params.licenseKey
   * @param {string} params.appId
   * @param {Function} params.authFunc
   */
  static init({ licenseKey, appId, authFunc }) {
    if (!isWebGLSupported()) {
      NOTICE.beautifyError({ code: -1, message: 'WebGL is not supported on current browser' });
      return -1;
    }
    config.auth = {
      licenseKey,
      appId,
      authFunc,
    };
    sdk = new TalBeauty();
    isUsing = true;
    return 0;
  }
  static uninit() {
    isUsing = false;
    delete config.auth;
    if (sdk) {
      sdk.destroy();
    }
  }
  static getInstance() {
    if (!TalBeauty.sdk) {
      sdk = new TalBeauty();
    }
    return TalBeauty.sdk;
  }
  constructor() {
    if (!config.auth) {
      NOTICE.beautifyError({ code: -2, message: 'Beauty-SDK has no auth' });
      throw new Error('Beauty-SDK has no auth');
    }
    super(config);

    this.on('created', this.onCreated.bind(this));
    this.on('cameraReady', this.onCameraReady.bind(this));
    this.on('resourceReady', this.onResourceReady.bind(this));
    this.on('ready', this.onReady.bind(this));
    this.on('error', this.onError.bind(this));

    this.state = SDK_STATE.UNINITIALIZED;
  }
  async initCore(params) {
    if (this.state < SDK_STATE.RESOURCE_READY) {
      return new Promise((resolve, reject) => {
        this.once('resourceReady', () => {
          super.initCore(params).then(resolve).catch(reject);
        });
      });
    } else {
      return super.initCore(params);
    }
  }
  onCreated() {
    console.log('created');
    this.state = SDK_STATE.CREATED;
    NOTICE.beautyCreated();
  }
  onCameraReady() {
    console.log('tencent-webar sdk cameraReady');
    this.state = SDK_STATE.CAMERA_READY;
  }
  onResourceReady() {
    console.log('tencent-webar sdk resourceReady');
    this.state = SDK_STATE.RESOURCE_READY;
  }
  onReady() {
    console.log('tencent-webar sdk ready');
    this.state = SDK_STATE.READY;
    if (config.beautify) {
      super.setBeautify(config.beautify);
    }

    if (config.avatar) {
      super.setAvatar(config.avatar);
    }

    if (config.background) {
      super.setBackground(config.background);
    }

    if (config.segmentationLevel) {
      super.setSegmentationLevel(config.segmentationLevel);
    }

    if (config.effect) {
      super.setEffect(config.effect, () => {});
    }

    if (config.filter) {
      super.setFilter(config.filter.id, config.filter.intensity, () => {});
    }
    NOTICE.beautyReady();
  }
  onError(error) {
    console.error('error: ', error.code, error.message);
    // https://cloud.tencent.com/document/product/616/75676 错误码含义参考该页面 - 错误处理
    if ([10000001, 20002001, 20001001].find((code) => code === error.code)) {
      isUsing = false;
    }
    NOTICE.beautifyError({ code: error.code, message: error.message });
  }
  setBeautify(params) {
    super.setBeautify(params);
    if (!config.beautify) {
      config.beautify = {};
    }
    Object.assign(config.beautify, params);
  }
  setAvatar(params) {
    super.setAvatar(params);
    config.avatar = JSON.parse(JSON.stringify(params));
  }
  setBackground(params) {
    super.setBackground(params);
    config.background = params;
  }
  setSegmentationLevel(level) {
    super.setSegmentationLevel(level);
    config.segmentationLevel = level;
  }
  setEffect(effect, callback) {
    super.setEffect(effect, callback);
    config.effect = effect;
  }
  setFilter(id, intensity, callback) {
    super.setFilter(id, intensity, callback);
    config.filter = { id, intensity };
  }
}

window.TalBeauty = TalBeauty;
export default TalBeauty;
